
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface FinancialInputSectionProps {
  companyNameInput: string;
  setCompanyNameInput: (value: string) => void;
  isLoadingFinancials: boolean;
  fetchFinancialData: (companyName: string) => void;
  rawFinancialResponse: string;
  canEdit: boolean;
}

export const FinancialInputSection = ({
  companyNameInput,
  setCompanyNameInput,
  isLoadingFinancials,
  fetchFinancialData,
  rawFinancialResponse,
  canEdit
}: FinancialInputSectionProps) => {
  const handleFetchData = () => {
    fetchFinancialData(companyNameInput);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Input
          type="text"
          placeholder="Enter company name"
          value={companyNameInput}
          onChange={(e) => setCompanyNameInput(e.target.value)}
          className="w-64"
          disabled={!canEdit}
        />
        <Button
          onClick={handleFetchData}
          disabled={isLoadingFinancials || !companyNameInput || !canEdit}
        >
          {isLoadingFinancials ? 'Loading...' : 'Fetch Financial Data'}
        </Button>
      </div>

      {rawFinancialResponse && (
        <div className="text-sm text-gray-600 mt-2">
          {rawFinancialResponse}
        </div>
      )}
    </div>
  );
};
